<template>
  <div class="main">
    <a-form-model class="user-layout-login" @keyup.enter.native="handleSubmit">
      <a-row :gutter="24" style="padding-bottom: 25px;">
        <a-col class="gutter-row" :span="6">
          <!-- <img alt="example" style="width: 100%" src="@/assets/login-header.png"/> -->
        </a-col>
        <a-col class="gutter-row" :span="18">
          <!-- <span style="font-size: 25px;">{{language['portal.ui2.s365']}}</span> -->
          <!-- <span style="font-size: 20px;">GENERAL AFFAIRS DIVISION</span> -->
        </a-col>
      </a-row>

      <div v-show="loginType=='login'">
        <div class="aui-formBox">
          <div class="aui-formWell">
            <div class="aui-flex aui-form-nav investment_title">

              <div class="aui-flex-box" :class="activeIndex === 'accountLogin' ? 'activeNav on' : ''" @click="loginClick('accountLogin')">
                {{ language['portal.ui2.accountLogin'] }}
              </div>
              <!--  相信登录  -->
              <div class="aui-flex-box" :class="activeIndex === 'civetLogin' ? 'activeNav on' : ''" @click="handleLoginWithIcivet">
                {{ language['portal.ui2.xiangxinAuth'] }}
              </div>

            </div>
          </div>
        </div>

        <login-account ref="alogin"  @validateFail="validateFail" @success="requestSuccess" @fail="requestFailed"></login-account>

        <a-form-model-item>
            <router-link :to="{ name: 'alteration',query:{type:'password'}}" class="forge-password" style="float: right;">
              {{language['sys.forget.password']}}<!--忘记密码-->
            </router-link>
        </a-form-model-item>

        <a-form-model-item>
          <j-language-menu ref="languageMenu" size="default"></j-language-menu>
        </a-form-model-item>

        <a-form-item style="margin-top:15px; bottom: 10px;">
          <a-button size="large"  type="primary"  htmlType="submit"  class="login-button"  @click.stop.prevent="handleSubmit" :disabled="loginBtn">{{language['system.loginButton']}}
          </a-button>
        </a-form-item>
      </div>

      <!-- <div v-show="loginType=='verify'">
        <verify ref="verify"  @validateFail="validatePhoneFail" @fail="requestPhoneFailed"  @success="phoneRequestSuccess" @verifyTypeChange="verifyTypeChange"/>
        <a-form-item style="margin-top:24px" v-if="verifyType=='phone'">
          <a-button size="large"  type="primary"  htmlType="submit"  class="login-button2" v-if="verifyType=='phone'"  @click.stop.prevent="handlePhoneSubmit" :disabled="loginBtn2">
            {{language['system.loginButton']}}
          </a-button>
          <a-button size="large"  style="margin-left: 4%;" htmlType="submit"  class="login-button2"  @click.stop.prevent="handlePhoneCancel" :disabled="loginBtn2">
            {{ language['portal.goBack']}}
          </a-button>
        </a-form-item>
        <a-form-item style="margin-top:24px" v-if="verifyType=='mail'">
          <a-button size="large"  type="primary"  htmlType="submit"  class="login-button2" v-if="verifyType=='mail'"  @click.stop.prevent="handlePhoneSubmit" :disabled="loginBtn2">
            {{language['system.loginButton']}}
          </a-button>
          <a-button size="large"  style="margin-left: 4%;" htmlType="submit"  class="login-button2"  @click.stop.prevent="handleMailCancel" :disabled="loginBtn2">
            {{ language['portal.goBack']}}
          </a-button>
        </a-form-item>
        <a-form-item style="margin-top:24px" v-if="!verifyType">
          <a-button size="large"   htmlType="submit"  class="login-button2"  @click.stop.prevent="verifyCancel" :disabled="loginBtn2">
            {{ language['portal.goBack']}}
          </a-button>
        </a-form-item>
      </div> -->


    </a-form-model>
    <user-password ref="userPassword"></user-password>
  </div>
</template>

<script>
import Vue from 'vue'
import {ACCESS_TOKEN, ENCRYPTED_STRING, LANGUAGE, USER_INFO} from '@/store/mutation-types'
import ThirdLogin from './third/ThirdLogin'
import LoginSelectTenant from './LoginSelectTenant'
import { getEncryptedString } from '@/utils/encryption/aesEncrypt'
import { timeFix } from '@/utils/util'
import debounce from 'lodash/debounce'

import LoginAccount from './LoginAccount'
import LoginPhone from './LoginPhone'
import JLanguageMenu from '@/components/jeecg/JLanguageMenu'
import VerifyPhone from './VerifyPhone'
import Verify from './Verify'
import UserPassword from '@/components/tools/UserPassword'

const LANG_CODE = {
  [LANGUAGE.CN]: 'cn',
  [LANGUAGE.TW]: 'tw',
  [LANGUAGE.ES]: 'en',
  [LANGUAGE.VN]: 'vn',
  [LANGUAGE.JP]: 'en'
}


export default {
    components: {
      LoginSelectTenant,
      ThirdLogin,
      LoginAccount,
      LoginPhone,
      VerifyPhone,
      Verify,
      JLanguageMenu,
      UserPassword
    },
    data () {
      return {
        customActiveKey: 'tab1',
        rememberMe: true,
        loginBtn: false,
        encryptedString:{
          key:"",
          iv:"",
        },
        activeIndex: "accountLogin",
        phone: '',
        account: '',
        loginBtn2: false,



        loginType:'',
        verifyType:'',
        verifySuccessUser:{},
      }
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
    },
    created() {
      Vue.ls.remove(ACCESS_TOKEN)
      this.getRouterData();
      this.rememberMe = true
      this.activeIndex = "accountLogin"
      this.loginType='login'
    },
    methods:{
      handleTabClick(key){
        this.customActiveKey = key
      },
      /**跳转到登录页面的参数-账号获取*/
      getRouterData(){
        this.$nextTick(() => {
          let temp = this.$route.params.username || this.$route.query.username || ''
          if (temp) {
            this.$refs.alogin.acceptUsername(temp)
          }
        })
      },

      //登录
      handleSubmit:debounce( function() {
        this.loginBtn = true;
        if (this.customActiveKey === 'tab1') {
          // 使用账户密码登录
          this.$refs.alogin.handleLogin(this.rememberMe)
        } else {
          //手机号码登录
          this.$refs.plogin.handleLogin(this.rememberMe)
        }
      },200),
      //登录
      handlePhoneSubmit:debounce( function() {
        if (this.customActiveKey === 'tab1') {
          this.loginBtn2 = true;
          //手机号码登录
          // this.$refs.verifyPhone.handleLogin(this.rememberMe)
          this.$refs.verify.handleLogin(this.verifyType,this.rememberMe)
        }
      },200),
      // 校验失败
      validateFail(){
        this.loginBtn = false;
      },
      // 校验失败
      validatePhoneFail(){
        this.loginBtn2 = false;
      },
      // 登录后台成功
      requestSuccess(loginResult){
        // this.$refs.loginSelect.show(loginResult)
        // this.loginSuccess()
        this.loginType  = 'verify'
        // let phone = Vue.ls.get(USER_INFO)?Vue.ls.get(USER_INFO).phone:null;
        // let account = Vue.ls.get(USER_INFO)?Vue.ls.get(USER_INFO).username:null;
        // this.phone = phone;
        // this.account = account;
        this.verifySuccessUser = {...loginResult}
        this.$refs.verify.username = this.verifySuccessUser.username;
        this.$refs.verify.password = this.verifySuccessUser.password;
        this.$refs.verify.email = this.verifySuccessUser.email;
        this.$refs.verify.phone = this.verifySuccessUser.phone;
        this.$refs.verify.checkKey = this.verifySuccessUser.checkKey;
      },
      phoneRequestSuccess(loginResult){
        this.$router.push({ path: "/dashboard/analysis" }).catch((res)=>{
          console.log('登录跳转首页出错,这个错误从哪里来的')
        })
        this.$notification.success({
          message: this.language['system.tipWelcome'],
          description: this.language['system.loginWelcomeMessage'],
        });
      },
      //登录后台失败
      requestFailed (err) {
        let description = ((err.response || {}).data || {}).message || err.message || this.$store.getters.language['system.loginPageMessage04']
        this.$notification[ 'error' ]({
          message:this.$store.getters.language['home.loginFailed'],
          description: description,
          duration: 4,
        });
        if(err.code == -1){
          this.$refs.userPassword.title = "修改密碼";
          this.$refs.userPassword.usernameShow = true;
          this.$refs.userPassword.show()
        }
        this.$refs.alogin.handleChangeCheckCode()
        // //账户密码登录错误后更新验证码
        // if(this.customActiveKey === 'tab1' && description.indexOf('密码错误')>0){
        //   this.$refs.alogin.handleChangeCheckCode()
        // }
        this.loginBtn = false;
      },
      //登录后台失败
      requestPhoneFailed (err) {
        let description = ((err.response || {}).data || {}).message || err.message || this.$store.getters.language['system.loginPageMessage04']
        this.$notification[ 'error' ]({
          message:this.$store.getters.language['home.loginFailed'],
          description: description,
          duration: 4,
        });
        this.loginBtn2 = false;
        // this.verifyCancel()
        /*if(this.verifyType=='phone'){

        }else if(this.verifyType=''){

        }*/
      },
      //登录成功
      loginSuccess () {
        // let phone = Vue.ls.get(USER_INFO)?Vue.ls.get(USER_INFO).phone:null;
        // let account = Vue.ls.get(USER_INFO)?Vue.ls.get(USER_INFO).username:null;
        // this.phone = phone;
        // this.account = account;

        /*this.$router.push({ path: "/dashboard/analysis" }).catch((res)=>{
          console.log('登录跳转首页出错,这个错误从哪里来的')
        })
        this.$notification.success({
          message: this.language['system.tipWelcome'],
          description: this.language['system.loginWelcomeMessage'],
        });*/
        // this.loginBtn = false;
        
      },



      handleLoginWithIcivet() {
        //sso跳转登录
        const lang = 'zh_CN';
        const url = `${process.env.VUE_APP_SSO_CODE_URI}&lang=${LANG_CODE[lang]}`;
        window.location.href=url;
      },
      /**
       * 切换登录方式
       */
      loginClick(type) {
        this.activeIndex = type;
        this.loginType = "accountLogin"
      },
      //获取密码加密规则
      getEncrypte(){
        var encryptedString = Vue.ls.get(ENCRYPTED_STRING);
        if(encryptedString == null){
          getEncryptedString().then((data) => {
            this.encryptedString = data
          });
        }else{
          this.encryptedString = encryptedString;
        }
      },
      handlePhoneCancel(){
        this.loginType = "verify";
        this.loginBtn2 = false;
        this.$refs.verify.initVerify()
      },
      handleMailCancel(){
        this.loginType = "verify";
        this.loginBtn2 = false;
        this.$refs.verify.initVerify()
      },
      verifyCancel(){
        this.loginType = "login";
        this.loginBtn = false;
      },
      verifyTypeChange(v){
        this.verifyType  =  v;
      }
    }

  }
</script>
<style lang="less" scoped>
  .user-layout-login {
    label {
      font-size: 14px;
    }
  .getCaptcha {
      display: block;
      width: 100%;
      height: 40px;
    }

  .forge-password {
      font-size: 14px;
    }

    button.login-button {
      padding: 0 15px;
      font-size: 16px;
      height: 40px;
      width: 100%;
    }

    button.login-button2 {
      padding: 0 15px;
      font-size: 16px;
      height: 40px;
      width: 48%;
    }

  .user-login-other {
      text-align: left;
      margin-top: 24px;
      line-height: 22px;

    .item-icon {
        font-size: 24px;
        color: rgba(0,0,0,.2);
        margin-left: 16px;
        vertical-align: middle;
        cursor: pointer;
        transition: color .3s;

      &:hover {
          color: #1890ff;
        }
      }

    .register {
        float: right;
      }
    }
  }

  .sign-in-other{
    .sign-in-xiangxin{
      flex: 1;
      width: 100%;
      padding: 0px;
      -webkit-tap-highlight-color: transparent;
      outline: 0px;
      border: 0px;
      cursor: pointer;
      user-select: none;
      vertical-align: middle;
      appearance: none;
      // font-weight: 600;
      // font-size: 0.9375rem;
      // color: var(--action-active);
      color: var(--surface);
      min-width: 64px;
      transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, -webkit-box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
      box-shadow: none;
      text-transform: none;
      text-align: center;
      border: 1px solid var(--border);
      background-color: rgb(33, 150, 243);

      /* UI Properties */
      font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-600) var(--unnamed-font-size-14)/var(--unnamed-line-spacing-22) var(--unnamed-font-family-noto-sans);
      letter-spacing: var(--unnamed-character-spacing-0);
    }
  }

</style>
<style>
  .valid-error .ant-select-selection__placeholder{
    color: #f5222d;
  }

  /*.aui-formBox {
    flex-basis: 40%;
    -webkit-flex-basis: 40%;
    box-sizing: border-box;
    padding: 30px 20px;
    background: #fff;
    box-shadow: 2px 9px 49px -17px #0000001a;
  }*/
  .aui-flex {
    display: flex;
    align-items: center;
    position: relative;
  }
  .aui-form-nav {
    text-align: center;
    padding-bottom: 20px;
  }
  .aui-flex-box {
    flex: 1;
    min-width: 0;
    font-size: 14px;
    color: #333;
  }
  .aui-form-nav .aui-flex-box {
    color: #040404;
    font-size: 18px;
    font-weight: 500;
    cursor: pointer;
  }
  .activeNav {
    position: relative;
  }
  .activeNav:after {
    content: "";
    position: absolute;
    z-index: 0;
    bottom: -10px;
    left: 50%;
    margin-left: -15px;
    width: 30px;
    height: 4px;
    background: #1b90ff;
    border-radius: 100px;
  }
</style>